import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { SearchBarMode } from '../../components/SearchBar/constants';
import { CROWS_SEARCH_ADJUSTMENTS, TEST_GROUP } from './constants';

export const resolveAiPillVariant = ({ rollouts, mode, expandable, children }) => {
    try {
        const { abTests = {}, userId, experience } = getContext();

        return (
            !!rollouts?.inCrowsSearchAdjustmentsExperimentRollout &&
            Number(abTests[CROWS_SEARCH_ADJUSTMENTS]) === TEST_GROUP &&
            !!userId &&
            !experience?.isBusiness &&
            mode === SearchBarMode.Default &&
            !expandable &&
            !React.Children.count(children)
        );
    } catch {
        return false;
    }
};
